module.exports = __webpack_public_path__ + "static/media/preview-tiktok-active.b699fa12.svg";